var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _g, _path15, _path16, _path17, _path18, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLibrary03(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 351,
    height: 234,
    viewBox: "0 0 351 234",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.995117,
    y: 0.683594,
    width: 350,
    height: 233,
    fill: "#C57E56"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M239.417 168.061L313.817 133.957L313.816 137.507L239.416 171.611L239.417 168.061Z",
    fill: "#3C6388"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M239.413 168.03L136.564 122.797L136.563 126.347L239.412 171.58L239.413 168.03Z",
    fill: "#2B4A67"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M221.202 179.634L118.354 134.401L136.558 126.344L239.407 171.577L221.202 179.634Z",
    fill: "#1C3043"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M136.488 122.799L210.889 88.6953L262.389 111.318L187.989 145.421L136.488 122.799Z",
    fill: "#4D85B9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M136.488 122.799L210.889 88.6953L262.389 111.318L187.989 145.421L136.488 122.799Z",
    fill: "url(#paint0_linear_569_27181)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M187.916 145.42L262.316 111.316L313.817 133.939L239.417 168.042L187.916 145.42Z",
    fill: "#4D85B9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M187.916 145.42L262.316 111.316L313.817 133.939L239.417 168.042L187.916 145.42Z",
    fill: "url(#paint1_linear_569_27181)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M191.194 131.9L142.821 110.332L142.818 122.266L191.191 143.834L191.194 131.9Z",
    fill: "#A5ABB0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M191.194 131.9L142.821 110.332L142.818 122.266L191.191 143.834L191.194 131.9Z",
    fill: "url(#paint2_linear_569_27181)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M239.568 153.479L191.195 131.789V143.917L239.568 165.485V153.479Z",
    fill: "#A5ABB0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M239.568 153.479L191.195 131.789V143.917L239.568 165.485V153.479Z",
    fill: "url(#paint3_linear_569_27181)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M239.572 153.566L307.627 121.68L307.623 133.613L239.568 165.499L239.572 153.566Z",
    fill: "#C9DDF0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M239.611 153.452L142.821 110.35L210.896 78.5703L307.646 121.677L239.611 153.452Z",
    fill: "#F2F9FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_569_27181",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 163,
    y: 83,
    width: 59,
    height: 35
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M181.122 117.054L163.193 107.338L204.007 83.7695L221.936 93.486L181.122 117.054Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_569_27181)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.398 108.85C176.333 108.886 176.275 108.923 176.202 108.959L174.203 109.984L169.174 107.026L171.166 106.001C172.852 105.144 174.669 105.311 176.144 106.19C177.597 107.033 177.852 108.014 176.398 108.857M163.818 106.99L178.753 115.776L181.573 114.323L176.703 111.459L179.145 110.202C179.269 110.136 179.392 110.071 179.509 110.006C182.263 108.414 181.921 106.372 179.058 104.693C176.115 102.964 172.249 102.644 169.16 104.243L163.826 106.99",
    fill: "#D1DFEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.324 107.236C187.532 107.694 187.619 108.478 188.549 109.002C189.486 109.576 190.976 109.663 191.863 109.205C191.885 109.191 191.907 109.183 191.928 109.169C192.691 108.733 192.619 107.933 191.689 107.381C190.736 106.822 189.239 106.742 188.411 107.178C188.375 107.192 188.346 107.214 188.316 107.228",
    fill: "#D1DFEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.185 100.195C193.12 100.231 193.054 100.267 192.982 100.304L190.99 101.328L185.954 98.3632L187.945 97.3385C189.631 96.481 191.448 96.6481 192.924 97.5275C194.377 98.3705 194.639 99.3516 193.185 100.187M180.598 98.3196L195.533 107.113L198.352 105.66L193.483 102.796L195.925 101.539C196.049 101.474 196.165 101.408 196.274 101.35C199.035 99.7586 198.694 97.7164 195.831 96.0304C192.887 94.3008 189.021 93.981 185.925 95.5726L180.591 98.3196",
    fill: "#D1DFEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.531 92.1778L207.473 100.971L210.249 99.5396L195.315 90.7461L192.531 92.1778Z",
    fill: "#D1DFEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.357 91.0228L208.019 93.2612C206.834 92.5053 206.645 91.4734 207.786 90.812C207.83 90.783 207.881 90.7612 207.931 90.7321C209.16 90.0853 210.991 90.2234 212.365 91.0155M205.293 89.5693C202.619 91.11 203.106 93.3992 206.456 95.3614C209.995 97.4544 214.13 97.7742 217.27 96.1681C217.379 96.11 217.488 96.0518 217.59 95.9937C219.799 94.7146 220.053 93.1449 218.447 91.7786L215.802 93.1449C216.18 93.6536 215.991 94.2423 215.155 94.7292C215.119 94.751 215.083 94.7728 215.039 94.7946C213.593 95.5286 211.638 95.3832 209.944 94.3876L216.914 90.7975L216.042 90.2888C212.226 88.0432 208.251 88.0359 205.577 89.4167C205.475 89.4676 205.381 89.5185 205.286 89.5766",
    fill: "#D1DFEB"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M239.693 153.642L191.195 131.819L259.249 100.035L307.747 121.858L239.693 153.642Z",
    fill: "#EAF5FF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M239.693 153.642L191.195 131.819L259.249 100.035L307.747 121.858L239.693 153.642Z",
    fill: "url(#paint4_linear_569_27181)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M231.09 122.475L191.195 131.816L259.249 100.032L299.144 90.6916L231.09 122.475Z",
    fill: "#E4EEF7"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M231.09 122.475L191.195 131.816L259.249 100.032L299.144 90.6916L231.09 122.475Z",
    fill: "url(#paint5_linear_569_27181)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_569_27181",
    x1: 184.089,
    y1: 103.041,
    x2: 199.439,
    y2: 145.421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D85B9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2264A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_569_27181",
    x1: 208.301,
    y1: 131.959,
    x2: 236.17,
    y2: 153.745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2264A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D85B9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_569_27181",
    x1: 191.195,
    y1: 139.298,
    x2: 142.818,
    y2: 118.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#82878B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A5ABB0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_569_27181",
    x1: 191.195,
    y1: 138.514,
    x2: 239.568,
    y2: 160.881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#858C92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A5ABB0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_569_27181",
    x1: 233.302,
    y1: 116.019,
    x2: 243.19,
    y2: 155.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A8B1B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF5FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_569_27181",
    x1: 230.602,
    y1: 106.997,
    x2: 243.448,
    y2: 131.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C7CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4EEF6",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLibrary03);
export default __webpack_public_path__ + "static/media/library_03.42bfcb1a1a113fa60b01efd0626c7b55.svg";
export { ForwardRef as ReactComponent };